/* ── PS Audio Player ── */
(function () {
  'use strict';

  /* ── SVG Icons ── */
  var ICO = {
    play: '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
    pause: '<svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>',
    prev: '<svg viewBox="0 0 24 24"><path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/></svg>',
    next: '<svg viewBox="0 0 24 24"><path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/></svg>',
    shuffle: '<svg viewBox="0 0 24 24"><path d="M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"/></svg>',
    repeat: '<svg viewBox="0 0 24 24"><path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/></svg>',
    repeatOne: '<svg viewBox="0 0 24 24"><path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/><text x="12" y="15.5" text-anchor="middle" font-size="7" fill="currentColor" font-weight="bold">1</text></svg>',
    vol: '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>',
    volMute: '<svg viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>'
  };

  /** Format seconds → m:ss */
  function fmt(s) {
    if (!s || !isFinite(s)) return '0:00';
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /** Active instance tracker — only one plays at a time */
  var activePlayer = null;

  /* ── PSAudioPlayer Class ── */
  function PSAudioPlayer(el) {
    this.root = el;
    this.tracks = [];
    this.idx = 0;
    this.shuffle = false;
    this.repeat = 0; // 0=off, 1=all, 2=one
    this.audio = new Audio();
    this.audio.preload = 'none';
    this.audio.volume = 1;
    this._dragging = false;
    this._volDragging = false;
    this._order = [];

    this._parseTracks();
    if (!this.tracks.length) return;
    this._render();
    this._bind();
    this._selectTrack(0, false);
  }

  PSAudioPlayer.prototype._parseTracks = function () {
    /* Try base64-encoded data-tracks first */
    var raw = this.root.getAttribute('data-tracks');
    if (raw) {
      try {
        var decoded = atob(raw);
        this.tracks = JSON.parse(decoded);
      } catch (e) {
        /* Maybe it's plain JSON (not base64) */
        try { this.tracks = JSON.parse(raw); } catch (e2) { /* skip */ }
      }
      return;
    }
    var script = this.root.querySelector('script[type="application/json"]');
    if (!script) return;
    try { this.tracks = JSON.parse(script.textContent); } catch (e) { /* skip */ }
  };

  PSAudioPlayer.prototype._render = function () {
    var html = '';
    /* Hero */
    html += '<div class="ps-player__hero">';
    html += '<img class="ps-player__cover" src="" alt="">';
    html += '<div class="ps-player__info">';
    html += '<p class="ps-player__title"></p>';
    html += '<p class="ps-player__artist"></p>';
    html += '<div class="ps-player__progress-wrap">';
    html += '<span class="ps-player__time ps-player__time--cur">0:00</span>';
    html += '<div class="ps-player__progress"><span class="ps-player__progress-fill" style="display:block;background:#71bdda"></span></div>';
    html += '<span class="ps-player__time ps-player__time--dur">0:00</span>';
    html += '</div>';
    html += '<div class="ps-player__controls">';
    html += '<button class="ps-player__btn ps-player__btn--shuffle" title="Shuffle">' + ICO.shuffle + '</button>';
    html += '<button class="ps-player__btn ps-player__btn--prev" title="Previous">' + ICO.prev + '</button>';
    html += '<button class="ps-player__btn ps-player__btn--play" title="Play">' + ICO.play + '</button>';
    html += '<button class="ps-player__btn ps-player__btn--next" title="Next">' + ICO.next + '</button>';
    html += '<button class="ps-player__btn ps-player__btn--repeat" title="Repeat">' + ICO.repeat + '</button>';
    html += '</div></div></div>';

    /* Separator */
    html += '<div class="ps-player__sep"></div>';

    /* Track list */
    html += '<ul class="ps-player__list">';
    for (var i = 0; i < this.tracks.length; i++) {
      var t = this.tracks[i];
      html += '<li class="ps-player__track" data-idx="' + i + '">';
      html += '<span class="ps-player__track-num">' + (i + 1) + '</span>';
      if (t.imgSrc) html += '<img class="ps-player__track-thumb" src="' + t.imgSrc + '" alt="" loading="lazy">';
      html += '<div class="ps-player__track-info">';
      html += '<div class="ps-player__track-title">' + (t.title || '') + '</div>';
      if (t.artist) html += '<div class="ps-player__track-artist">' + t.artist + '</div>';
      html += '</div>';
      html += '<span class="ps-player__track-dur">' + (t.duration || '') + '</span>';
      html += '<div class="ps-player__eq"><span class="ps-player__eq-bar"></span><span class="ps-player__eq-bar"></span><span class="ps-player__eq-bar"></span></div>';
      html += '</li>';
    }
    html += '</ul>';

    /* Clear script tag, inject HTML */
    var script = this.root.querySelector('script[type="application/json"]');
    if (script) script.remove();
    this.root.innerHTML = html;

    /* Cache DOM refs */
    this.$cover = this.root.querySelector('.ps-player__cover');
    this.$title = this.root.querySelector('.ps-player__title');
    this.$artist = this.root.querySelector('.ps-player__artist');
    this.$curTime = this.root.querySelector('.ps-player__time--cur');
    this.$durTime = this.root.querySelector('.ps-player__time--dur');
    this.$progress = this.root.querySelector('.ps-player__progress');
    this.$fill = this.root.querySelector('.ps-player__progress-fill');
    this.$playBtn = this.root.querySelector('.ps-player__btn--play');
    this.$shuffleBtn = this.root.querySelector('.ps-player__btn--shuffle');
    this.$repeatBtn = this.root.querySelector('.ps-player__btn--repeat');
    this.$list = this.root.querySelector('.ps-player__list');
    this.$tracks = this.root.querySelectorAll('.ps-player__track');

    /* Force inline styles for bars — PageFly may override CSS */
    this.$progress.style.background = '#555';
    this.$fill.style.background = '#71bdda';

    /* Set track list height based on data-max-tracks (default: 4) */
    var maxTracks = parseInt(this.root.getAttribute('data-max-tracks'), 10) || 4;
    this.$list.style.maxHeight = (maxTracks * 58) + 'px';
  };

  PSAudioPlayer.prototype._bind = function () {
    var self = this;

    /* Play / Pause */
    this.$playBtn.addEventListener('click', function () {
      self.audio.paused ? self.play() : self.pause();
    });

    /* Prev / Next */
    this.root.querySelector('.ps-player__btn--prev').addEventListener('click', function () { self.prev(); });
    this.root.querySelector('.ps-player__btn--next').addEventListener('click', function () { self.next(); });

    /* Shuffle */
    this.$shuffleBtn.addEventListener('click', function () {
      self.shuffle = !self.shuffle;
      self.$shuffleBtn.classList.toggle('ps-player__btn--active', self.shuffle);
      if (self.shuffle) self._buildOrder();
    });

    /* Repeat */
    this.$repeatBtn.addEventListener('click', function () {
      self.repeat = (self.repeat + 1) % 3;
      self.$repeatBtn.classList.toggle('ps-player__btn--active', self.repeat > 0);
      self.$repeatBtn.innerHTML = self.repeat === 2 ? ICO.repeatOne : ICO.repeat;
    });

    /* Progress seek */
    this.$progress.addEventListener('mousedown', function (e) { self._dragging = true; self._seek(e); });
    this.$progress.addEventListener('touchstart', function (e) { self._dragging = true; self._seek(e.touches[0]); }, { passive: true });
    document.addEventListener('mousemove', function (e) { if (self._dragging) self._seek(e); });
    document.addEventListener('touchmove', function (e) { if (self._dragging) self._seek(e.touches[0]); }, { passive: true });
    document.addEventListener('mouseup', function () { self._dragging = false; });
    document.addEventListener('touchend', function () { self._dragging = false; });

    /* Audio events */
    this.audio.addEventListener('timeupdate', function () { self._updateProgress(); });
    this.audio.addEventListener('loadedmetadata', function () {
      self.$durTime.textContent = fmt(self.audio.duration);
    });
    this.audio.addEventListener('ended', function () { self._onEnded(); });

    /* Track list clicks */
    this.$list.addEventListener('click', function (e) {
      var li = e.target.closest('.ps-player__track');
      if (!li) return;
      var idx = parseInt(li.dataset.idx, 10);
      if (idx === self.idx && !self.audio.paused) {
        self.pause();
      } else if (idx === self.idx) {
        self.play();
      } else {
        self._selectTrack(idx, true);
      }
    });
  };

  PSAudioPlayer.prototype._selectTrack = function (idx, autoplay) {
    this.idx = idx;
    var t = this.tracks[idx];
    this.$cover.src = t.imgSrc || '';
    this.$title.textContent = t.title || '';
    this.$artist.textContent = t.artist || '';
    this.$curTime.textContent = '0:00';
    this.$durTime.textContent = t.duration || '0:00';
    this.$fill.style.width = '0%';

    /* Highlight active track */
    for (var i = 0; i < this.$tracks.length; i++) {
      this.$tracks[i].classList.toggle('ps-player__track--active', i === idx);
      this.$tracks[i].classList.remove('ps-player__track--playing');
    }

    /* Load & optionally play */
    this.audio.src = t.audioSrc;
    if (autoplay) this.play();
  };

  PSAudioPlayer.prototype.play = function () {
    /* Pause any other active player */
    if (activePlayer && activePlayer !== this) {
      activePlayer.pause();
    }
    activePlayer = this;

    this.audio.play();
    this.$playBtn.innerHTML = ICO.pause;
    this.$tracks[this.idx].classList.add('ps-player__track--playing');

    /* Scroll active track into view */
    this.$tracks[this.idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  PSAudioPlayer.prototype.pause = function () {
    this.audio.pause();
    this.$playBtn.innerHTML = ICO.play;
    this.$tracks[this.idx].classList.remove('ps-player__track--playing');
  };

  PSAudioPlayer.prototype.prev = function () {
    if (this.audio.currentTime > 3) {
      this.audio.currentTime = 0;
      return;
    }
    var next = this.shuffle ? this._shufflePrev() : this.idx - 1;
    if (next < 0) next = this.tracks.length - 1;
    this._selectTrack(next, !this.audio.paused);
  };

  PSAudioPlayer.prototype.next = function () {
    var next = this.shuffle ? this._shuffleNext() : this.idx + 1;
    if (next >= this.tracks.length) next = 0;
    this._selectTrack(next, !this.audio.paused);
  };

  PSAudioPlayer.prototype._onEnded = function () {
    if (this.repeat === 2) {
      this.audio.currentTime = 0;
      this.audio.play();
      return;
    }
    var next = this.shuffle ? this._shuffleNext() : this.idx + 1;
    if (next >= this.tracks.length) {
      if (this.repeat === 1) {
        next = 0;
      } else {
        this.pause();
        return;
      }
    }
    this._selectTrack(next, true);
  };

  PSAudioPlayer.prototype._updateProgress = function () {
    if (this._dragging) return;
    var pct = this.audio.duration ? (this.audio.currentTime / this.audio.duration) * 100 : 0;
    this.$fill.style.width = pct + '%';
    this.$curTime.textContent = fmt(this.audio.currentTime);
  };

  PSAudioPlayer.prototype._seek = function (e) {
    var rect = this.$progress.getBoundingClientRect();
    var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    this.$fill.style.width = (pct * 100) + '%';
    if (this.audio.duration) {
      this.audio.currentTime = pct * this.audio.duration;
      this.$curTime.textContent = fmt(this.audio.currentTime);
    }
  };

  PSAudioPlayer.prototype._setVol = function (e) {
    var rect = this.$volBar.getBoundingClientRect();
    var pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    this.audio.volume = pct;
    this._updateVolUI();
  };

  PSAudioPlayer.prototype._updateVolUI = function () {
    this.$volFill.style.width = (this.audio.volume * 100) + '%';
    this.$volBtn.innerHTML = this.audio.volume === 0 ? ICO.volMute : ICO.vol;
  };

  /* Shuffle helpers */
  PSAudioPlayer.prototype._buildOrder = function () {
    this._order = [];
    for (var i = 0; i < this.tracks.length; i++) this._order.push(i);
    /* Fisher-Yates */
    for (var j = this._order.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var tmp = this._order[j];
      this._order[j] = this._order[k];
      this._order[k] = tmp;
    }
    this._orderPos = this._order.indexOf(this.idx);
  };

  PSAudioPlayer.prototype._shuffleNext = function () {
    if (!this._order.length) this._buildOrder();
    this._orderPos = (this._orderPos + 1) % this._order.length;
    return this._order[this._orderPos];
  };

  PSAudioPlayer.prototype._shufflePrev = function () {
    if (!this._order.length) this._buildOrder();
    this._orderPos = (this._orderPos - 1 + this._order.length) % this._order.length;
    return this._order[this._orderPos];
  };

  /* ── Auto-init ── */
  function init() {
    var els = document.querySelectorAll('[data-ps-player]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._psPlayer) {
        els[i]._psPlayer = new PSAudioPlayer(els[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section events (PageFly, theme editor) */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('pagefly:updated', init);

  /* Lightweight poll for PageFly dynamic injection — stops once all players found */
  var pollCount = 0;
  var pollTimer = setInterval(function () {
    pollCount++;
    var els = document.querySelectorAll('[data-ps-player]');
    var allDone = true;
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._psPlayer) { allDone = false; break; }
    }
    if (els.length > 0 && allDone) { clearInterval(pollTimer); return; }
    if (els.length > 0) init();
    if (pollCount > 40) clearInterval(pollTimer); /* stop after 10s */
  }, 250);
})();
